import * as RadixDialog from '@radix-ui/react-dialog';
import React, { useState } from 'react';

import { BaseButton } from '../../../../components/button/BaseButton';
import { getDisplayError } from '@utils/get-display-error';
import { countSelfBills, type ISelfBillKindConfig } from '../self-bill-kind-config';

interface IBulkApproveConfirmDialogProps {
  config: ISelfBillKindConfig;
  isOpen: boolean;
  onClose: () => void;
  draftCount: number;
  isBusy: boolean;
  onApprove: (andSend: boolean) => Promise<void>;
}

export const BulkApproveConfirmDialog: React.FC<IBulkApproveConfirmDialogProps> = (props) => {
  const { config, isOpen, onClose, draftCount, isBusy, onApprove } = props;
  const [error, setError] = useState('');

  const run = async (andSend: boolean) => {
    setError('');
    try {
      await onApprove(andSend);
    } catch (err) {
      setError(getDisplayError(err));
    }
  };

  const noun = countSelfBills(config, draftCount);

  return (
    <RadixDialog.Root open={isOpen} onOpenChange={(open) => !open && !isBusy && onClose()}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="dialog-overlay" />
        <RadixDialog.Content className="dialog-content">
          <RadixDialog.Title className="heading-one mb-4">{`${noun} goedkeuren?`}</RadixDialog.Title>

          <RadixDialog.Description className="mb-4">
            {config.createsPurchaseOnApproval
              ? `Elk concept krijgt een factuurnummer en een aankoopfactuur. Met "Goedkeuren & verzenden" gaan ze ook naar de vervoerders (Peppol/e-mail).`
              : `Elk concept krijgt een nummer. Met "Goedkeuren & verzenden" gaan ze ook per e-mail naar de vervoerders.`}
          </RadixDialog.Description>

          {error && <div className="text-sm text-negative-text mb-2 w-full">{error}</div>}

          <div className="flex justify-between">
            <div>
              <BaseButton
                isLoading={isBusy}
                disabled={isBusy}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onClose();
                }}
              >
                Annuleer
              </BaseButton>
            </div>
            <div className="flex gap-2">
              <BaseButton
                color="default"
                isLoading={isBusy}
                disabled={isBusy}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  run(false);
                }}
              >
                Goedkeuren
              </BaseButton>
              <BaseButton
                color="primary"
                isLoading={isBusy}
                disabled={isBusy}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  run(true);
                }}
              >
                Goedkeuren & verzenden
              </BaseButton>
            </div>
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
